import { ApiResult, HttpClient } from "../http.js";
import { TeamDto } from "../types/teams.js";

/**
 * `/api/teams` — the thin, **enabled-only** team read for non-settings consumers (the planning
 * board, the employee form). Gated on `[Authorize]` plus the org query filter and no permission
 * key: the field default set grants `users.viewSelf` and never `users.view`, so gating it would
 * render an unnamed planning board for every svend.
 *
 * Settings needs archived teams too — use `settings.listTeams()` there.
 */
export class TeamsApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<ApiResult<TeamDto[]>> {
    return this.http.get<TeamDto[]>("/api/teams");
  }
}
